import React from 'react';
import OrangeLoader from '@/assets/animation/loading_orange.gif';
import OrangeMiddleLoader from '@/assets/animation/loading_orange_middle.gif';
import './style.scss';

function Loader(styleName = '', loaderData = '') {
  return (
    <div className={styleName}>
      <img src={loaderData} />
    </div>
  );
}

export function DialogueLoader() {
  return Loader('sp-dialogue-loader-orange', OrangeLoader);
}


export function AgentDialogueLoader() {
  return Loader('sp-agent-dialogue-loader', OrangeMiddleLoader);
}
